import { render, staticRenderFns } from "./fault-list.vue?vue&type=template&id=8478c85e&scoped=true"
import script from "./fault-list.vue?vue&type=script&lang=js"
export * from "./fault-list.vue?vue&type=script&lang=js"
import style0 from "./fault-list.vue?vue&type=style&index=0&id=8478c85e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8478c85e",
  null
  
)

export default component.exports